import { InfoIcon, Typography } from 'components'

export const InfoBox = () => (
	<div className='flex items-center rounded-md border border-black-800 bg-black-850 p-5 xl:block xl:space-y-2.5'>
		<InfoIcon />
		<Typography
			class='ml-2.5 xl:ml-0'
			color='text-black-200'
			text="If you have more members to add don't worry, you can always add more later."
			variant='text3'
			weight='font-light'
		/>
	</div>
)
